import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    fetchGetFuelCalibration,
    fetchSaveFuelCalibration,
    fetchDeleteFuelCalibration,
} from "./actions";
import {IFuelTank} from "../../../models/IFuelCalibration";

interface IFuelCalibrationState {
    // Тарировка текущей открытой машины.
    tanks: IFuelTank[];
    isLoading: boolean;
    isSaving: boolean;
    errorMessage: string;
}

const initialState: IFuelCalibrationState = {
    tanks: [],
    isLoading: false,
    isSaving: false,
    errorMessage: "",
};

export const FuelCalibrationSlice = createSlice({
    name: "fuelCalibration",
    initialState,
    reducers: {
        // Сброс при уходе со страницы машины, чтобы тарировка не «протекла».
        clearFuelCalibration: (state) => {
            state.tanks = [];
            state.errorMessage = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGetFuelCalibration.pending, (state) => {
                state.isLoading = true;
                state.errorMessage = "";
            })
            .addCase(
                fetchGetFuelCalibration.fulfilled,
                (state, action: PayloadAction<IFuelTank[]>) => {
                    state.isLoading = false;
                    state.tanks = action.payload;
                },
            )
            .addCase(fetchGetFuelCalibration.rejected, (state, action) => {
                state.isLoading = false;
                state.errorMessage = action.payload as string;
            })
            .addCase(fetchSaveFuelCalibration.pending, (state) => {
                state.isSaving = true;
            })
            .addCase(
                fetchSaveFuelCalibration.fulfilled,
                (state, action: PayloadAction<IFuelTank[]>) => {
                    state.isSaving = false;
                    state.tanks = action.payload;
                },
            )
            .addCase(fetchSaveFuelCalibration.rejected, (state) => {
                state.isSaving = false;
            })
            .addCase(fetchDeleteFuelCalibration.fulfilled, (state) => {
                state.tanks = [];
            });
    },
});

export const { clearFuelCalibration } = FuelCalibrationSlice.actions;
export default FuelCalibrationSlice.reducer;